<template>
  <div class="authentication">
    <div class="authentication_top">
      <van-icon style="position: absolute; left: 10px" size="25" name="arrow-left" @click="$router.push('My');" />
      <div class="my">认证</div>
    </div>
    <div class="authentication_bottom">
      <div class="scholar">
        <img class="authentication_img" src="../../../../assets/mylogin/team.png" alt="" />
        <div class="authentication_middle">
          <h3 class="authentication_title">学者认证</h3>
          <p class="authentication_content">
            完成学者认证,开通中文知识网百家号，百家在线学者空间
          </p>
        </div>
        <van-button class="authentication_but" type="info" @click="toAuthentication('scholarAuthentication')">去认证</van-button>
      </div>
      <!-- <div class="scholar">
        <img class="authentication_img" src="../../../../assets/mylogin/data.png" alt="" />
        <div class="authentication_middle">
          <h3 class="authentication_title">期刊认证</h3>
          <p class="authentication_content">
            完成期刊认证，开通中文知识网百科号，百科在线期刊空间
          </p>
        </div>
        <van-button class="authentication_but" type="info" @click="toAuthentication('periodicalAuthentication')">去认证</van-button>
      </div>
      <div class="scholar">
        <img class="authentication_img" src="../../../../assets/mylogin/jg_icon.png" alt="" />
        <div class="authentication_middle">
          <h3 class="authentication_title">机构认证</h3>
          <p class="authentication_content">
            完成机构认证，开通中文知识网机构认证
          </p>
        </div>
        <van-button class="authentication_but" type="info" @click="toAuthentication('organizationAuthentication')">去认证</van-button>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  name: "authentication",
  data() {
    return {};
  },
  methods: {
    toAuthentication(type) {
      this.$router.push({name: type})
    },
  },
};
</script>

<style lang="scss" scoped>
.authentication {
  width: 100vw;
  min-height: 100vh;
  overflow: hidden;
  background: #f5f5f5;

  .authentication_top {
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #fff;
    line-height: 44px;
    align-content: center;

    .my {
      font-size: 18px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      background: #fff;
      text-align: center;
    }
  }

  .authentication_bottom {
    width: 100%;

    .scholar {
      display: flex;
      align-items: center;
      margin: 12px auto;
      padding: 20px 10px;
      width: 351px;
      background: #fff;
      border-radius: 8px;

      .authentication_img {
        flex: none;
        width: 45px;
        height: 44px;
      }

      .authentication_middle {
        margin: 0 14px;

        .authentication_title {
          font-size: 17px;
          color: #333333;
          line-height: 21px;
        }

        .authentication_content {
          margin-top: 10px;
          font-size: 13px;
          color: #999999;
          line-height: 20px;
        }
      }

      .authentication_but {
        flex: none;
        padding: 0 5px;
        width: 65px;
        height: 27px;
        border-radius: 13px;
      }
    }
  }
}
</style>